import { useEffect, useState } from 'react'
import useComputed from '@/hooks/use-computed'
import isObject from '@/utils/is-object.js'
import api from '@/services/api/config.js'

const useConfig = () => {

	const [loading, setLoading] = useState(false)
	const [errorMsg, setErrorMsg] = useState()

	const [profile] = useState(JSON.parse(sessionStorage.getItem('profile')))


	const [config, setConfig, [identity, provideItems, consumeItems, isProvider, isConsumer, provideSystems, consumeSystems, systems, provideHasOnBehalfOf, consumeHasOnBehalfOf, isAbleToPassiveProvide, isAbleToPassiveConsume]] = useComputed({ produces: null, consumes: null },
		value => value?.identity,
		value => value?.produces ? value.produces : [],
		value => value?.consumes ? value.consumes : [],
		value => value?.produces?.length > 0,
		value => value?.consumes?.length > 0,
		value => value?.produces ? getProvideSystems(value) : [],
		value => value?.consumes ? getConsumeSystems(value) : [],
		value => value?.identity && value?.produces && value.consumes ? getAllSystems(value) : [],
		value => value?.produces?.some(el => el.to.some(e => e.on_behalf_of && e.on_behalf_of.length > 0)),
		value => value?.consumes?.some(el => el.from.some(e => e.on_behalf_of && e.on_behalf_of.length > 0)),
		value => value?.produces?.some(el => Object.keys(el.querySchema).length !== 0),
		value => value?.consumes?.some(el => Object.keys(el.querySchema).length !== 0),
	)

	useEffect(() => {
		if (profile?.tncStatus) {
			fetch()
		}
	}, [])

	async function fetch() {

		const awaitRecuFun = async () => {
			return new Promise((resolve) => {
				setTimeout(resolve, 1000);
			});
		};

		const recurFun = async () => {
			if (sessionStorage.getItem('config_call_status') === 'fetching') {
				await awaitRecuFun();
				return recurFun();
			}
			const seshConfig = sessionStorage.getItem('config')
			if (seshConfig) {
				return setConfig(JSON.parse(seshConfig))
			}

			setLoading(true)
			sessionStorage.setItem('config_call_status', 'fetching')
			const [error, data] = await api.index()
			sessionStorage.setItem('config', JSON.stringify(data))
			sessionStorage.removeItem('config_call_status')
			setLoading(false)

			if (error) {
				return setErrorMsg(error)
			}
			if (!isObject(data)) {
				return setErrorMsg(error?.error?.message || 'Config is not an object')
			}
			return setConfig(data)
		}

		return recurFun();
	}

	function getAllSystems(value) {

		const provideSystemsData = value.produces.map(element => element.to)
		const consumeSystemsData = value.consumes.map(element => element.from)

		const allSystems = provideSystemsData.concat(consumeSystemsData).flat(1)
		const uniqueSystems = allSystems.filter((currentSystem, index, all) => all.findIndex(system => system.id === currentSystem.id) === index)
		const myPitstopSystem = {
			id: value.identity.id,
			name: 'My Pitstop',
			systems: [{
				id: value.identity.id
			}],
			system: {
				id: value.identity.id
			},
			on_behalf_of: []
		}

		uniqueSystems.push(myPitstopSystem)

		return uniqueSystems
	}

	function getConsumeSystems(value) {
		const consumeSystemsData = value.consumes.map(element => element.from)
		const allConsumeSystems = consumeSystemsData.flat(1)
		return allConsumeSystems.filter((currentSystem, index, all) => all.findIndex(system => system.id === currentSystem.id) === index)
	}

	function getProvideSystems(value) {
		const provideSystemsData = value.produces.map(element => element.to)
		const allProvideSystems = provideSystemsData.flat(1)
		return allProvideSystems.filter((currentSystem, index, all) => all.findIndex(system => system.id === currentSystem.id) === index)
	}

	async function find() {

		setLoading(true)

		const [error, data] = await api.index()

		setLoading(false)

		if (error) {
			return setErrorMsg(error)
		}

		if (!isObject(data)) {
			return setErrorMsg('Config is not an object')
		}

		sessionStorage.setItem('config', JSON.stringify(data))
		return data
	}

	const getUniqueDataElements = () =>{
		const de=  [...consumeItems, ...provideItems]
		return de.reduce((unique, item) => {
			return unique.some(el => el.id === item.id) ? unique : [...unique, item];
		}, []);
	}

	return {
		config,
		consumeItems,
		consumeSystems,
		error: errorMsg,
		fetch,
		identity,
		isConsumer,
		isProvider,
		loading,
		provideItems,
		provideSystems,
		systems,
		provideHasOnBehalfOf,
		consumeHasOnBehalfOf,
		find,
		isAbleToPassiveProvide,
		isAbleToPassiveConsume,
		getUniqueDataElements
	}
}

export default useConfig
